// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v9Z1","importantInfo":"styles_importantInfo__3juPZ"};